import { checkEmail, checkExistingEmail, fetchList } from "Source/api/workstream";

export const checkWorkstreamEmail = (params) => {
    return params.workstreamId
        ? checkExistingEmail(params)
        : checkEmail(params);
}

export const searchWorkstream = (params) => {
    return fetchList(params);
}